import styled, { ITheme } from '../../../theme'

const ExpandButton = styled.a<{ size?: number }>`
  width: ${({ size }) => (size ? 30 * size : 30)}px;
  height: ${({ size }) => (size ? 30 * size : 30)}px;
  border-radius: 3px;
  background-color: ${(props: ITheme) =>
    props.theme.colors.palette.pinkishGrey};

  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  margin-left: ${({ size }) => (size ? 15 * size : 15)}px;
  cursor: pointer;

  &:hover {
    background-color: ${(props: ITheme) =>
      props.theme.colors.palette.warmGreytThree};
  }
`
export default ExpandButton
